import map from 'lodash/map';
import times from 'lodash/times';
import each from 'lodash/each';

export const SEARCH_TERM_COLORS = [
  '#0099FF',
  '#F5A623',
  '#F45C79',
  '#00FBFF',
  '#BEFF7D'
];
export const TWITTER_SUBTYPE_OPTIONS = ['tweet', 'retweet', 'quote', 'reply'];
export const STORIES_PAGE_SIZE = 25;
// use shortened version for pendo
export const MEDIA_OPTIONS_SHORTENED = [
  'without a Video or Image',
  'with an Image',
  'with a Video',
  'with either a Video or an Image'
];
export const MEDIA_OPTIONS = MEDIA_OPTIONS_SHORTENED.map((text) => `Show only mentions ${text}`);
export const TWITTER_SUBTYPE_OPTIONS_SORTED = TWITTER_SUBTYPE_OPTIONS.slice().sort();
const SETTINGS_VERSION = '1';

let LANGUAGE_LABEL_MAP = {};
const findLanguageByLabel = (label) =>label && LANGUAGE_LABEL_MAP[label];
// sets the langugages when DiscoverHistorics first loads
export const setAvailableLanguages = (languages) => {
  LANGUAGE_LABEL_MAP = {};
  each(languages, (language) => language.label && (LANGUAGE_LABEL_MAP[language.label] = language));
  return LANGUAGE_LABEL_MAP;
};

export const checkAdditionalFiltersForChanges = (settings) => {
  if (settings && settings.filters) {
    const { twitterContent, mediaChecked, excludeUSChecked } = settings.filters;
    return !!(mediaChecked || excludeUSChecked || (twitterContent && twitterContent.length !== TWITTER_SUBTYPE_OPTIONS.length));
  }
  return false;
};

export const addDefaultElements = (array=[], elem) => {
  const results = [];
  times(5, (i) => results[i] = array[i] || elem);
  return results;
};

const convertAdditionalFiltersToStr = (settings) => {
  let settingsString = '';
  if (checkAdditionalFiltersForChanges(settings)) {
    const { twitterContent=[], mediaChecked=false, mediaOption='0', excludeUSChecked=false } = settings.filters;
    settingsString = `${SETTINGS_VERSION},`;
    if (twitterContent.length) {
      TWITTER_SUBTYPE_OPTIONS_SORTED.forEach((subtype) => {
        settingsString += twitterContent.includes(subtype) ? '1' : '0';
      });
    } else {
      settingsString += '1111';
    }
    settingsString += ',';
    settingsString += mediaChecked ? '1' : '0';
    settingsString += mediaOption;
    settingsString += ',';
    settingsString += excludeUSChecked ? '1' : '0';
  }
  return settingsString;
};


export const convertAdditionalFiltersArrToStr = (settingsArr) => {
  return settingsArr.map(convertAdditionalFiltersToStr);
};

const convertStringToAdditionalFilters = (settingsString) => {
  const settings = {};
  if (settingsString) {
    settings.filters = { twitterContent: [] };
    const [ version, twitterContentStr, mediaOptionStr, excludeUSCheckedStr ] = settingsString.split(',');
    each(twitterContentStr, (num, i) => {
      if (num === '1') {
        settings.filters.twitterContent.push(TWITTER_SUBTYPE_OPTIONS_SORTED[i]);
      }
    });
    settings.filters.mediaChecked = mediaOptionStr[0] === '1';
    settings.filters.mediaOption = mediaOptionStr[1];
    settings.filters.excludeUSChecked = excludeUSCheckedStr === '1';
  }
  return settings;
};

export const convertStrToAdditionalFilters = (settingsStringArr) => {
  return addDefaultElements(settingsStringArr, '').map(convertStringToAdditionalFilters);
};

export const convertSelectedLanguagesToStr = (selectedLanguages) => {
  return map(selectedLanguages, (arr) => map(arr, (language = {}) => language.label || '').join());
};

export const convertStrToSelectedLanguages = (selectedLanguagesParam=[]) => {
  return addDefaultElements(selectedLanguagesParam, '')
    .map((str) => str.split(','))
    .map((arr) => arr.map(findLanguageByLabel).filter((obj) => !!obj));
};

export const convertEnabledKeywordsToStr = (translations, searchTerms) => {
  return map(translations, (transArr=[]) => {
    return map(transArr, ({keywords=[]}) => {
      return keywords.reduce((str, {enabled}) => {
        return str += enabled ? '1' : '0';
      }, '');
    }).join();
  });
};
